import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { httpGet, httpPost } from '../../helpers/http.js';

export const loadRegistrationInfo = createAsyncThunk(
    'registration/fetch',
    async (_, { getState }) => {
        const { env, auth } = getState();

        const params = new URLSearchParams();
        (env.registrationKeys || []).forEach(k => params.append("keys", k));

        const result = await httpGet(`${env.settings.catalogApi}/api/1.0/registrations/${env.portalIdentifier}?${params}`, auth.user);

        const orderMap = new Map(
            env.registrationKeys.map((key, index) => [key, index])
        );

        result.registrationInfo.sort((a, b) => {
            const indexA = orderMap.get(a.key) ?? Infinity;
            const indexB = orderMap.get(b.key) ?? Infinity;
            return indexA - indexB;
        });

        return result;
    },
);

export const saveRegistrationInfo = createAsyncThunk(
    'registration/save',
    async (_, { getState }) => {
        const { registration: state, env, auth } = getState();

        return await httpPost(`${env.settings.catalogApi}/api/1.0/registrations/${env.portalIdentifier}`, auth.user, state.current);
    },
);

const registrationSlice = createSlice({
    name: 'registration',
    initialState: {
        status: 'idle',
        error: null,
    },
    reducers: {
        updateRegistration: (state, action) => {
            const { key, changes } = action.payload;

            state.current.registrations = state.current.registrations.some((o) => o.registrationInfoKey === key)
                ? state.current.registrations.map((o) => o.registrationInfoKey === key ? {...o, ...changes} : o)
                : [...state.current.registrations, changes];
            state.dirty = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadRegistrationInfo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(loadRegistrationInfo.fulfilled, (state, action) => {
                const {user, registrationInfo} = action.payload;

                state.status = 'success';
                state.current = user,
                state.info = registrationInfo,
                state.dirty = false;
            })
            .addCase(loadRegistrationInfo.rejected, (state, action) => {
                state.status = 'failed';
                state.current = null;
                state.info = [];
                state.error = action.error;
            })
            .addCase(saveRegistrationInfo.pending, (state) => {
                state.status = 'saving';
            })
            .addCase(saveRegistrationInfo.fulfilled, (state) => {
                state.status = 'success';
                state.dirty = false;
            })
            .addCase(saveRegistrationInfo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error;
            })
    },
});

export const { updateRegistration } = registrationSlice.actions;

export default registrationSlice.reducer;
